export function isChineseLocale(language) {
  return language === 'tc' || language === 'sc';
}

export function stripProgrammeOfferPrefix(title) {
  if (!title) return title;
  return title
    .replace(/^Offered by [^:：]+[:：]\s*/i, '')
    .replace(/^由.+?[開开][辦办][:：]\s*/, '');
}

export function getProgrammeFullTitles(programme) {
  if (!programme) return { en: '', cn: '' };
  return {
    en: stripProgrammeOfferPrefix(programme.full_title_en || ''),
    cn: stripProgrammeOfferPrefix(programme.full_title_cn || ''),
  };
}

export function getProgrammePrimaryTitle(programme, language) {
  if (!programme) return '';
  const { full_title_en, full_title_cn, short_name, code } = programme;
  if (isChineseLocale(language)) {
    return stripProgrammeOfferPrefix(full_title_cn || full_title_en || short_name || code);
  }
  return stripProgrammeOfferPrefix(full_title_en || full_title_cn || short_name || code);
}

export function getProgrammeRankingBarTitle(programme, language) {
  if (!programme) return '';
  if (!isChineseLocale(language) && programme.short_name) {
    return programme.short_name;
  }
  return getProgrammePrimaryTitle(programme, language);
}

export function getProgrammeSecondaryTitle(programme, language) {
  if (!programme) return null;
  const primary = getProgrammePrimaryTitle(programme, language);
  const secondary = stripProgrammeOfferPrefix(
    isChineseLocale(language) ? programme.full_title_en : programme.full_title_cn
  );
  return secondary && secondary !== primary ? secondary : null;
}
